import type { ReactNode } from 'react'
import { useWorkspacePermissions } from '@/hooks/useWorkspacePermissions'

interface WorkspaceWriteGateProps {
  workspaceId?: string
  children: ReactNode
  fallback?: ReactNode
}

export function WorkspaceWriteGate({
  workspaceId,
  children,
  fallback = null,
}: WorkspaceWriteGateProps) {
  const { canWorkspaceWrite, isLoading } = useWorkspacePermissions(workspaceId)

  if (isLoading || !canWorkspaceWrite) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
